import useWindowDimensions from '@/hooks/useWindowDimensions.tsx';
import StaffBack from '@/pages/ViewId/Staff/StaffBack.tsx';
import StaffFront from '@/pages/ViewId/Staff/StaffFront.tsx';
import PanZoomWrapper from '@/pages/ViewId/Student/PanZoomWrapper.tsx';
import StudentBack from '@/pages/ViewId/Student/StudentBack.tsx';
import StudentFront from '@/pages/ViewId/Student/StudentFront.tsx';
import type {IdCard} from '@/utils/IdCard.ts';
import {Box, useTheme} from '@mui/material';
import type * as React from 'react';
import Barcode from './Barcode';

export type View = 'front' | 'back' | 'barcode';

type Props = {
    idCard: IdCard;
    view: View;
};

const ViewId: React.FC<Props> = ({idCard, view}: Props) => {
    const theme = useTheme();
    const {width} = useWindowDimensions();
    const padding = 32;

    if (view === 'barcode') {
        return (
            <Box
                sx={{
                    padding: theme.spacing(2),
                }}
            >
                <Barcode idCard={idCard} />
            </Box>
        );
    }

    if (view === 'front') {
        return (
            <Box>
                {idCard.type === 'student' && (
                    <Box
                        sx={{
                            padding: theme.spacing(2),
                            width: `calc(1200px + ${theme.spacing(2)}px)`,
                            height: `calc(800px + ${theme.spacing(2)}px)`,
                        }}
                    >
                        <PanZoomWrapper>
                            <StudentFront idCard={idCard} width={`${width - padding}px`} />
                        </PanZoomWrapper>
                    </Box>
                )}
                {idCard.type === 'staff' && (
                    <Box
                        sx={{
                            padding: theme.spacing(2),
                            width: `calc(800px + ${theme.spacing(2)}px)`,
                            height: `calc(1200px + ${theme.spacing(2)}px)`,
                        }}
                    >
                        <PanZoomWrapper>
                            <StaffFront idCard={idCard} width={`${width - padding}px`} />
                        </PanZoomWrapper>
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <Box>
            {idCard.type === 'student' && (
                <Box
                    sx={{
                        padding: theme.spacing(2),
                        width: `calc(1200px + ${theme.spacing(2)}px)`,
                        height: `calc(800px + ${theme.spacing(2)}px)`,
                    }}
                >
                    <PanZoomWrapper>
                        <StudentBack idCard={idCard} width={`${width - padding}px`} />
                    </PanZoomWrapper>
                </Box>
            )}
            {idCard.type === 'staff' && (
                <Box
                    sx={{
                        padding: theme.spacing(2),
                        width: `calc(800px + ${theme.spacing(2)}px)`,
                        height: `calc(1200px + ${theme.spacing(2)}px)`,
                    }}
                >
                    <PanZoomWrapper>
                        <StaffBack idCard={idCard} width={`${width - padding}px`} />
                    </PanZoomWrapper>
                </Box>
            )}
        </Box>
    );
};

export default ViewId;
